import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star-fill",
  "use": "star-fill-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"star-fill\"><path d=\"M4.254 14.816c-.788.559-1.832-.215-1.527-1.132l1.419-4.263-3.723-2.64c-.795-.564-.396-1.816.579-1.815h4.627L7.053.684c.304-.912 1.594-.912 1.898 0l1.424 4.282h4.627c.974 0 1.373 1.251.578 1.815l-3.722 2.64 1.419 4.263c.305.917-.74 1.69-1.527 1.132l-3.748-2.66-3.748 2.66z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol